import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaChartPie,
  FaList,
  FaUserTie,
  FaUserFriends,
  FaSignOutAlt,
  FaKey,
  FaCodeBranch,
  FaBoxes,
  FaUsers,
  FaTrash,
} from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import { useEffect, useState } from "react";
import DBFLogo from "../../logo.png";
import SALogo from "../../main-logo.png";
import demoLogo from "../../demo-logo.png";
import "./AppSidebar.css";

export default function AppSidebar({
  collapsed,
  setCollapsed,
  isHovered,
  setIsHovered,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [logo, setLogo] = useState(SALogo);

  const loginUserName = user?.name || "";
  const loginUserId = user?.userId || "";
  const loginUserRoleId = user?.roleId || null;

  useEffect(() => {
    if(user?.prefix === 'KF'){
      setLogo(SALogo)
    }else if(user?.prefix === 'DEMO'){
      setLogo(demoLogo)
    }else if(user?.prefix === 'DBF'){
      setLogo(DBFLogo)
    }
    setIsHovered(false);
  }, [setIsHovered]);

  const isSidebarCollapsed = collapsed && !isHovered;

  const avatarInitials = loginUserName
    ? loginUserName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
    : "?";

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <Sidebar
      collapsed={isSidebarCollapsed}
      backgroundColor="#1f2937"
      rootStyles={{
        height: "100vh",
        position: "fixed",
        zIndex: 100,
        display: "flex",
        flexDirection: "column",
      }}
      // onMouseEnter={() => collapsed && setIsHovered(true)}
      // onMouseLeave={() => collapsed && setIsHovered(false)}
    >
      {/* LOGO TOP SECTION */}
      <div
        style={{
          padding: isSidebarCollapsed ? "16px 0" : "16px 12px",
          borderBottom: "1px solid #374151",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 48,
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            height: "auto",
            width: "100%",
            objectFit: "contain",
          }}
        />
      </div>

      {/* MENU WRAPPER */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        {/* TOP MENU ITEMS */}
        <Menu
          className="sidebar-menu"
          menuItemStyles={{
            button: ({ active }) => ({
              color: "#fff",
              backgroundColor: active ? "#4b5563" : "transparent",
              "&:hover": { backgroundColor: "#374151" },
              borderLeft: active
                ? "3px solid var(--primary-color, #60a5fa)"
                : "3px solid transparent",
              fontWeight: active ? "bold" : "normal",
            }),
          }}
        >
          {loginUserRoleId !== 3 && (
            <MenuItem
              icon={<FaChartPie />}
              component={<Link to="/dashboard" />}
              active={isActive("/dashboard")}
            >
              Dashboard
            </MenuItem>
          )}

          <MenuItem
            icon={<FaList />}
            component={<Link to="/list" />}
            active={isActive("/list")}
          >
            Customers
          </MenuItem>

          {loginUserRoleId === 1 && (
            <MenuItem
              icon={<FaUserTie />}
              component={<Link to="/employers" />}
              active={isActive("/employers")}
            >
              Employers
            </MenuItem>
          )}

          {loginUserRoleId === 1 && (
            <MenuItem
              icon={<FaUsers />}
              component={<Link to="/users" />}
              active={isActive("/users")}
            >
              Users
            </MenuItem>
          )}

          {loginUserRoleId !== 3 && (
            <MenuItem
              icon={<FaUserFriends />}
              component={<Link to="/employees" />}
              active={isActive("/employees")}
            >
              Employees
            </MenuItem>
          )}

          {loginUserRoleId !== 3 && loginUserRoleId !== 1 && (
            <MenuItem
              icon={<FaCodeBranch />}
              component={<Link to="/branches" />}
              active={isActive("/branches")}
            >
              Branches
            </MenuItem>
          )}

          {loginUserRoleId !== 3 && loginUserRoleId !== 1 && (
            <MenuItem
              icon={<FaBoxes />}
              component={<Link to="/stock" />}
              active={isActive("/stock")}
            >
              Custom Items
            </MenuItem>
          )}

          <MenuItem
            icon={<FaTrash />}
            component={<Link to="/deleted-customers" />}
            active={isActive("/deleted-customers")}
          >
            Deleted Customers
          </MenuItem>

        </Menu>

        {/* PROFILE SECTION AT BOTTOM - HOVER MENU */}
        <div
          className="sidebar-profile-wrapper"
          onMouseEnter={() => setProfileMenuOpen(true)}
          onMouseLeave={() => setProfileMenuOpen(false)}
        >
          <div
            className="sidebar-profile-trigger"
            style={{
              color: "white",
              padding: isSidebarCollapsed ? "12px 0" : "12px 15px",
              borderTop: "1px solid #374151",
              display: "flex",
              alignItems: "center",
              flexDirection: isSidebarCollapsed ? "column" : "row",
              gap: isSidebarCollapsed ? "4px" : "10px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: "#4b5563",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: 14,
                flexShrink: 0,
              }}
            >
              {avatarInitials}
            </div>
            {!isSidebarCollapsed && (
              <div style={{ minWidth: 0, flex: 1 }}>
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: 14,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {loginUserName}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    opacity: 0.7,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {loginUserId}
                </div>
              </div>
            )}
          </div>
          {profileMenuOpen && (
            <div className="sidebar-profile-menu">
              <Link
                to="/password-update"
                className="sidebar-profile-menu-item"
                onClick={() => setProfileMenuOpen(false)}
              >
                <FaKey style={{ marginRight: 8, flexShrink: 0 }} />
                Change Password
              </Link>
              <button
                type="button"
                className="sidebar-profile-menu-item sidebar-profile-menu-item-button"
                onClick={() => {
                  setProfileMenuOpen(false);
                  handleLogout();
                }}
              >
                <FaSignOutAlt style={{ marginRight: 8, flexShrink: 0 }} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </Sidebar>
  );
}